import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { DASHBOARD_PORTAL_PREFIX } from '@yourownmetric/shared'

import { syncSelfAnalytics } from '@/app/selfAnalytics'
import { useAppSelector } from '@/app/hooks'
import { appModeForHost, parseAppHosts } from '@/modules/portal/portalHost'

/** An agency's custom portal domain is never the YOM app. */
const PORTAL_HOST =
    appModeForHost(
        globalThis.location?.hostname ?? 'localhost',
        parseAppHosts(import.meta.env.VITE_APP_HOSTS),
    ).kind === 'portal-host'

/** Keeps YOM's own product analytics (Y-APP) in step with the signed-in session. */
export function SelfAnalyticsTracker() {
    const user = useAppSelector(s => s.auth.user)
    const tenantId = useAppSelector(s => s.auth.tenant?.id ?? null)
    // Client portals are the agency's clients, not YOM users: never tracked.
    const { pathname } = useLocation()
    const portal = PORTAL_HOST || pathname.startsWith(DASHBOARD_PORTAL_PREFIX)
    useEffect(() => {
        if (portal) {
            return
        }
        syncSelfAnalytics(
            user ? { userId: user.id, orgId: tenantId, superAdmin: !!user.isSuperAdmin } : null,
        )
    }, [user, tenantId, portal])
    return null
}
